import { ElMessage } from "element-plus";
import type { RequestPayloadMap, ResponseDataMap } from "./types";
import { ref, type Ref } from "vue";

const API_PREFIX = "/router/rest";
export const DEFAULT_APP_KEY = 10145;

export type ResponseResult<T> = {
  msg: string;
  code: HTTP_CODE;
  data: T;
  traceId: string;
};

export enum HTTP_CODE {
  SUCCESS = 0,
  EMPTY = 60010,
  INVALID = 6001,
  EXPIRED = 100201,
}

const loadings = new Proxy(
  {} as Record<keyof RequestPayloadMap, Ref<boolean>>,
  {
    get(target, prop: keyof RequestPayloadMap) {
      target[prop] = target[prop] || ref(false);
      return target[prop];
    },
  }
);

export const request = async <K extends keyof RequestPayloadMap>(
  code: K,
  body: RequestPayloadMap[K],
  init: RequestInit & { silent?: boolean } = {}
): Promise<ResponseDataMap[K]> => {
  const url = API_PREFIX + "?" + code;

  const headers = {
    method: code,
    "Content-Type": "application/json",
    appKey: DEFAULT_APP_KEY,
  } as unknown as RequestInit["headers"];

  const config: RequestInit = {
    body: JSON.stringify(body),
    headers,
    method: "POST",
    ...init,
  };

  try {
    loadings["web.basicBiz.address.getMultiLevelSubList"].value = true;
    const response = await fetch(url, config);
    const data: ResponseResult<ResponseDataMap[K]> = await response.json();

    if (data.code !== HTTP_CODE.SUCCESS) {
      init.silent || ElMessage.error(data.msg);

      throw data;
    }

    return data.data;
  } finally {
    loadings["web.basicBiz.address.getMultiLevelSubList"].value = false;
  }
};

request.loadings = loadings;

export * from "./types";
